import React, { Component, Suspense } from 'react';

import EmailProtectFragmentStart from './components/EmailProtectFragmentStart';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
         
    }
  }

  render() {
    return (
      <Suspense fallback={(<div>Loading...</div>)}>
        <EmailProtectFragmentStart />
      </Suspense>
    )
  }
}

export default (App)

